<template>
    <div class="profile-form">
        <el-form :model="user" label-width="120px" style="text-align: left;">
            <!---------------------------->
            <!-- User username -->
            <!---------------------------->
            <el-form-item label="Username">
                {{user.username}}
            </el-form-item>

            <!---------------------------->
            <!-- User Email -->
            <!---------------------------->
            <el-form-item label="Email">
                {{user.email}}
            </el-form-item>

            <!---------------------------->
            <!-- User Last active -->
            <!---------------------------->
            <el-form-item label="Last active">
                {{user.activityDate ? moment(user.activityDate).fromNow() : 'Not active yet'}}
            </el-form-item>

            <!---------------------------->
            <!-- User Status -->
            <!---------------------------->
            <el-form-item label="Status">
                <el-image :src="user.currentStatus === 'online' ? onlineIcon : offlineIcon" class="user-status"></el-image>
                {{user.currentStatus}}
            </el-form-item>
        </el-form>

        <!---------------------------->
        <!--  Game matches -->
        <!---------------------------->
        <el-divider>
            <span class="hidden-sm-and-down">
                Last game updates
            </span>
            <span class="hidden-md-and-up">
                Updates
            </span>
        </el-divider>

        <el-row type="flex" justify="center">
            <el-col :xs="{span: 24}" :sm="{span: 24}">
                <games-table v-if="games.length && !loading"
                             :loading="false"
                             :done="true"
                             :infinityScroll="false"
                             :games="games"
                             :addGameEnabled="!!peak"
                             :isPeaking="!!peak"
                             :gameIcons="gameImages"
                             :systemIcons="systemImages"
                             :onEmit="onEmit"
                             :options="{
                                tableWidth: {
                                    xs: 22,
                                    sm: 22
                                },
                                gameRowOptions: {
                                    modifiedDate: { show: true, xs: 0, sm: 4 },
                                    systemIcon: { show: true, xs: 3, sm: 2  },
                                    systemShortName: { show: true, xs: 0, sm: 2  },
                                    gameIcon: { show: true, xs: 0, sm: 1  },
                                    gameTitle: { show: true, xs: 19, sm: 12  },
                                    gameTag: { show: true, xs: 2, sm: 3  },
                                }
                             }"
                ></games-table>
            </el-col>
        </el-row>
    </div>
</template>

<script>
// @ is an alias to /src
import chunkArray from '@/utils/chunk-array.js'
import ErrorHandling from '@/utils/error-handling.js'
import moment from 'moment'

import GamesTable from '@/components/games-table'

export default {
  name: 'Profile',
  components: {
    GamesTable
  },
  props: ['user', 'peak', 'onEmit'],
  created () {
    this.getGames()
  },

  data () {
    return {
      loading: false,

      games: [],

      systemImages: {},
      gameImages: {},

      onlineIcon: require(`@/assets/icon-onn.png`),
      offlineIcon: require(`@/assets/icon-off.png`),
      awayIcon: require(`@/assets/icon-away.png`)
    }
  },

  methods: {
    chunkArray,
    moment,

    async getGames () {
      if (this.loading) {
        this.$message.error('Already loading, please wait!')
        return
      }

      this.loading = true

      const res = await this.$http.get('games', { params: { sort: 'lastModified', userToPeak: this.user._id } })

      if (res.errors && res.errors.length) {
        ErrorHandling(res.errors, 'lastModifiedGames', { handleMessage: this.$message.error })
        this.loading = false
      }

      else {
        for (let game of res.list) {
          if (game.avatar && !this.gameImages[game.avatar]) {
            this.gameImages[game.avatar] = require(`@/assets/icon-${game.avatar}.png`)
          }

          if (this.systemImages[game.systemAvatar]) continue
          this.systemImages[game.systemAvatar] = require(`@/assets/${game.systemAvatar}-mini.png`)
        }

        this.games = res.list

        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
    @import '../styles/variables.scss';
    .profile-form {

        .el-form-item__label {
            font-size: $font-size-regular;
        }

        .el-form-item__content {
            font-size: $font-size-regular;
        }

        .el-form-item {
            margin: 0px;
        }

        .user-status {
            width: 15px;
            height: 15px;
        }

        @media screen and (max-width: 35em) {
            .el-form-item__label {
                width: 100px !important;
                text-align: left;
                margin-left: 10px;
            }

            .el-form-item__content{
                margin-left: 100px !important;
                overflow: hidden;
            }
        }

        @media screen and (max-width: 71em) and (min-width: 35em) {
            .el-form-item__label {
                width: 100px !important;
                text-align: left;
                margin-left: 4em;
            }

            .el-form-item__content{
                margin-left: 4em !important;
            }
        }
    }
</style>
